import { render, staticRenderFns } from "./PcTaxId.vue?vue&type=template&id=53433fea"
import script from "./PcTaxId.vue?vue&type=script&lang=js"
export * from "./PcTaxId.vue?vue&type=script&lang=js"
import style0 from "./PcTaxId.vue?vue&type=style&index=0&id=53433fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports